import { Github, Linkedin, Mail, ArrowUpRight } from "lucide-react";
import { profile } from "../../data/content";
import { Reveal, Overline } from "./Reveal";

export const Footer = () => (
  <footer
    id="contact"
    data-testid="footer-section"
    className="relative bg-[var(--bg-base)]"
  >
    <div className="max-w-6xl mx-auto px-6 md:px-12 py-24 md:py-32">
      <Reveal>
        <Overline>Contact</Overline>
        <h2 className="mt-5 font-heading font-extrabold text-4xl sm:text-5xl md:text-6xl tracking-tight text-primary-c leading-[1.02] max-w-3xl">
          Let&apos;s build something
          <br />
          <span className="text-secondary-c">worth maintaining.</span>
        </h2>
        <p className="mt-6 max-w-xl text-base md:text-lg text-secondary-c leading-relaxed">
          I&apos;m {profile.availability.toLowerCase()}. If you&apos;re solving a hard
          backend or SaaS problem, I&apos;d like to hear about it.
        </p>

        <div className="mt-10 flex flex-wrap items-center gap-3">
          <a
            data-testid="footer-email-btn"
            href={`mailto:${profile.email}`}
            className="group inline-flex items-center gap-2 bg-white text-black font-medium rounded-full px-6 py-3 hover:bg-neutral-200 transition-colors"
          >
            <Mail className="w-4 h-4" strokeWidth={2} />
            {profile.email}
          </a>
          <a
            data-testid="footer-resume-btn"
            href={profile.resume}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 border border-[var(--border-strong)] text-primary-c font-medium rounded-full px-6 py-3 hover:bg-white/5 transition-colors"
          >
            Résumé <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
          </a>
        </div>
      </Reveal>

      <div className="mt-20 pt-8 border-t border-[var(--border-subtle)] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div>
          <p className="font-heading font-extrabold text-primary-c tracking-tight">
            {profile.name}
          </p>
          <p className="mt-1 text-sm text-tertiary-c">
            {profile.role} · {profile.location}
          </p>
        </div>
        <div className="flex items-center gap-4">
          {[
            { Icon: Github, href: profile.github, label: "github" },
            { Icon: Linkedin, href: profile.linkedin, label: "linkedin" },
            { Icon: Mail, href: `mailto:${profile.email}`, label: "email" },
          ].map(({ Icon, href, label }) => (
            <a
              key={label}
              data-testid={`footer-social-${label}`}
              href={href}
              target={label === "email" ? undefined : "_blank"}
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-[var(--border-subtle)] text-secondary-c hover:text-primary-c hover:border-[var(--border-strong)] transition-colors"
              aria-label={label}
            >
              <Icon className="w-4 h-4" strokeWidth={1.5} />
            </a>
          ))}
        </div>
      </div>
      <p className="mt-8 text-xs text-tertiary-c">
        © {new Date().getFullYear()} {profile.name}. Designed & built with intent.
      </p>
    </div>
  </footer>
);
